import { BigNumber } from '@ethersproject/bignumber';
import { formatUnits } from '@ethersproject/units';
import { Network } from '@manifoldxyz/js-ts-utils';
import { coinbaseApi } from '@/api/coinbase';

/**
 * Formats a number to display nicely in USD
 * @param value - The number to format
 * @returns The formatted USD value
 */
export function formatUSD(value: number, maxDecimals = 2): string {
  if (value === 0) return '$0.00';
  if (value < 0.01 && value > 0) {
    return '<$0.01';
  }
  // Standard USD formatting
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: maxDecimals,
  });
}

/**
 * Converts a balance to USD
 * @param networkId - The network id
 * @param balance - The balance to convert
 * @returns The balance in USD
 */
export async function convertToUSD(networkId: number, balance: BigNumber) {
  // Cast chainId to NetworkId enum type
  const networkConfig = Network.NETWORK_CONFIGS[networkId as Network.NetworkId];
  if (!networkConfig) {
    return;
  }
  const nativeCurrency = networkConfig.nativeCurrency;
  const usdRate = await coinbaseApi.getCurrencySymbolUsdRate(
    nativeCurrency.symbol.includes('ETH') ? 'ETH' : nativeCurrency.symbol,
  );
  if (usdRate && balance) {
    const formattedBalance = parseFloat(formatUnits(balance, nativeCurrency.decimals));
    return formattedBalance * usdRate;
  }
}
